module.exports = __webpack_public_path__ + "static/kugluk-dadd0ba99690cecaed43dff187986516.png";